export const Orders = () => {
  return <div>This is orders page</div>;
};
